<template>
  <div class="placeOrder">
    <template v-if="controllerNumber.length">
      <ticketInfo
        :selectDate="selectDate"
        :fullTicketInfo="fullTicketInfo"
        :controllerNumber="controllerNumber">
      </ticketInfo>
      <fillContacts
        v-if="
          !(
            screenData.needContactName == 'false' &&
            screenData.needContactMobile == 'false' &&
            screenData.needContactEmail == 'false' &&
            screenData.needContactHKMTPassport == 'false' &&
            screenData.needContactIDCard == 'false' &&
            screenData.needContactPassport == 'false'
          )"
        :realName="userInfo.realName"
        :mobile="userInfo.mobile"
        :email="userInfo.email"
        :idCardNo="userInfo.idCardNo"
        @matchContact="matchContact"
        :screenData="screenData">
      </fillContacts>
      <topContacts
        v-if="checkNeedUsefulPerson"
        ref="DOMTopContacts"
        :controllerNumber="controllerNumber"
        @changeTopContacts="changeTopContacts"
        :usefulPersonInfos="usefulPersonInfos">
      </topContacts>
      <inputDevice
        :class="{ 'not-show': !checkNeedUsefulPerson }"
        @updataControllerNumber="updataControllerNumber"
        ref="DOMInputDevice"
        :selectDate="selectDate"
        :controllerNumber="controllerNumber">
      </inputDevice>
      <calculationAction
        ref="DOMCalculationAction"
        :nextStepName="screenData.saleType == 'free' ? '立即预约' : '立即支付'"
        @nextStep="nextStep"
        :fullPrice="Number(fullPrice)"
        :controllerNumber="controllerNumber"
      ></calculationAction>
        <multiTicketDiversion
          v-if="touristShuntSwitch"
          @clickPopup="clickPopup"
          :tourist="usefulPersonInfos[usefulPersonInfoActiveIndex]"
          :touristShuntSwitch="touristShuntSwitch"
          :hitUsefulPersonInfo="hitUsefulPersonInfo">
        </multiTicketDiversion>
    </template>
  </div>
</template>

<script>
import loading from '@/components/common/loading';
import ticketInfo from "@/components/buyTickets/placeOrder/ticketInfo";
import fillContacts from "@/components/buyTickets/placeOrder/fillContacts";
import { getCreateOrder,getBoatCreateOrder } from "@/service/buyTickets/touristfit.js";
import topContacts from "@/components/buyTickets/placeOrder/topContacts";
import inputDevice from "@/components/buyTickets/placeOrder/inputDevice";
import multiTicketDiversion from "@/components/buyTickets/placeOrder/multiTicketDiversion";
import calculationAction from "@/components/buyTickets/shoppingCart/calculationAction";
import {
  getUsefulPerson,
  getUsefulPersonUpdPerson,
  getUsefulPersonBatchAddPersonn,
} from "@/service/oftencontact/oftencontactList.js";

export default {
  name: "touristplaceOrder",
  data() {
    return {
      controllerNumber: [],
      fullTicketInfo: {},
      fullPrice: 0,
      selectDate: {},
      userInfo: {},
      contactItems: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        contactCerType: "id_card",
        contactCerNo: "",
      },
      usefulPersonInfos: [],
      hitUsefulPersonInfo: [],
      usefulPersonInfoActiveIndex: null,
      touristShuntSwitch: false,
      createdDoading: loading(),
      screenData: {},
      checkNeedUsefulPerson: true,
    }
  },
  created(){
    const keepState = this.initialization();
    if(keepState){
      this.getUserInfo();
      this.checkNeedUsefulPerson = this.needUsefulPerson()
      this.checkNeedUsefulPerson && this.getCommonVisitors();
    };
  },
  methods: {
    initialization(){
      const orderinformation = JSON.parse(window.sessionStorage.getItem('orderinformation')) || false;
      if(!orderinformation){
        this.$router.push('/');
        return false;
      }
      const { controllerNumber, selectDate, fullTicketInfo } = orderinformation;
      const _controllerNumber = JSON.parse(window.sessionStorage.getItem('controllerNumber')) || false;
      if(_controllerNumber){
        this.controllerNumber = _controllerNumber;
      }else{
        this.controllerNumber = controllerNumber;
      };
      this.fullTicketInfo = fullTicketInfo;
      this.selectDate = selectDate;
      this.generateScreenData();
      return true;
    },
    mergeCommonVisitors(target, tourist){
      target.traverllerCerNo = tourist.certNo;
      target.traverllerCerType = tourist.certType;
      target.traverllerEmail = tourist.email;
      target.traverllerName = tourist.name;
      target.traverllerPhone = tourist.mobile;
      if(tourist.id){
        target.id = tourist.id;
      }
    },
    clickPopup({ type, index = null }){
      const _controllerNumber = this.$refs.DOMInputDevice._controllerNumber;
      const ticket = _controllerNumber.find(v => v.metaTicketInfo.productId === this.hitUsefulPersonInfo[index].metaTicketInfo.productId);
      const tourist = this.usefulPersonInfos[this.usefulPersonInfoActiveIndex];
      if(type === 'determine'){
        const isSurplus = ticket.orderItemAttr.some(v => {
          if(!v.traverllerCerNo){
            this.mergeCommonVisitors(v, tourist)
            return true;
          };
        });
        if(!isSurplus){
          const currentOrderItem = ticket.orderItemAttr[0];
          this.usefulPersonInfos.some(v => {
            if(v.certNo === currentOrderItem.traverllerCerNo){
              v.active = false;
              return true;
            };
          });
          this.mergeCommonVisitors(currentOrderItem, tourist);
        };
      };
      this.$refs.DOMTopContacts.$forceUpdate();
      this.$refs.DOMInputDevice.$forceUpdate();
      if(type === 'cancel'){
        tourist.active = false;
      }
      this.touristShuntSwitch = false;
      this.$beyondHiding(false);
    },
    updataControllerNumber({
      type,
      data,
      currentItem,
    }){
      if(type === 'updata'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
      } else if(type === 'delete'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
        this.deleteControllerNumber(currentItem);
      };
    },
    deleteControllerNumber(currentItem){
      this.usefulPersonInfos.some(v => {
        if(v.certNo === currentItem.traverllerCerNo){
          v.active = false;
          return true;
        };
      });
      this.$refs.DOMTopContacts.$forceUpdate();
    },
    generateScreenData(){
      const controllerNumber = this.controllerNumber;
      const checkMergeRule = Boolean(controllerNumber.filter(v => v.count).length > 1);
      if(checkMergeRule){
        const screenData = controllerNumber[0].metaTicketInfo;
        controllerNumber.forEach(({ metaTicketInfo }) => {
          if(metaTicketInfo.needContactEmail === 'true')screenData.needContactEmail = metaTicketInfo.needContactEmail;
          if(metaTicketInfo.needContactHKMTPassport === 'true')screenData.needContactHKMTPassport = metaTicketInfo.needContactHKMTPassport;
          if(metaTicketInfo.needContactIDCard === 'true')screenData.needContactIDCard = metaTicketInfo.needContactIDCard;
          if(metaTicketInfo.needContactMobile === 'true')screenData.needContactMobile = metaTicketInfo.needContactMobile;
          if(metaTicketInfo.needContactName === 'true')screenData.needContactName = metaTicketInfo.needContactName;
          if(metaTicketInfo.needContactPRC === 'true')screenData.needContactPRC = metaTicketInfo.needContactPRC;
          if(metaTicketInfo.needContactPassport === 'true')screenData.needContactPassport = metaTicketInfo.needContactPassport;
        });
        this.screenData = screenData;
      }else{
        this.screenData = controllerNumber.find(v => v.count).metaTicketInfo;
      };
    },
    async nextStep(){
      this.$refs.DOMCalculationAction.changeDetailed(false);
      // 匹配联系人校验规则元门票数据
      const screenData = this.screenData;
      // 校验联系人
      if (screenData.needContactName === "true" && !this.contactItems.contactName)return this.$toast("请输入联系人姓名");
      if (screenData.needContactMobile === "true" && !this.contactItems.contactPhone)return this.$toast("请输入联系人手机号");
      if (screenData.needContactEmail === "true" && !this.contactItems.contactEmail)return this.$toast("请输入联系人邮箱");
      if (!(screenData.needContactIDCard === "false" && screenData.needContactHKMTPassport === "false" && screenData.needContactPassport === "false" && screenData.needContactPRC === "false") && !this.contactItems.contactCerNo)
      return this.$toast("请输入联系人证件号");
      if (screenData.needContactMobile === "true" && !this.$reg.checkPhone(this.contactItems.contactPhone) && !this.$reg.checkLandline(this.contactItems.contactPhone))return this.$toast("联系人电话格式错误");
      if (screenData.needContactEmail === "true" && !this.$reg.checkEmail(this.contactItems.contactEmail))return this.$toast("联系人邮箱号码错误");
      if (screenData.needContactIDCard === "true" && !this.$reg.checkIDCard(this.contactItems.contactCerNo))return this.$toast("联系人证件号错误");
      if(this.checkNeedUsefulPerson){
        // 输入组件自我检查并返回检查结果
        const failText = this.$refs.DOMInputDevice.checkControllerNumber();
        if(failText)return this.$toast(failText);
      }
      const saleDate = this.selectDate;
      console.log(saleDate)
      let periodId
      if(saleDate.datePeriodInfo){
        periodId  = saleDate.datePeriodInfo.periodId;
      }else{
        periodId = ''
      }
      let parameter = {
        appCode: "pdc7vkn6",
        userId: this.userInfo.userId,
        contactName: this.contactItems.contactName && this.contactItems.contactName.trim(),
        contactPhone: this.contactItems.contactPhone && this.contactItems.contactPhone.trim(),
        contactEmail: this.contactItems.contactEmail && this.contactItems.contactEmail.trim(),
        contactCerType: this.contactItems.contactCerType,
        contactCerNo: this.contactItems.traverllerCerNo && this.contactItems.traverllerCerNo.trim(),
        payType: "WEIXIN",
        orderItems: [],
      };
      this.controllerNumber.forEach(item => {
        const { needCertAsMedia, productId, saleAgeInfos } = item.metaTicketInfo;
        const currentTag = item.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key === 'full' ? 'adult' : 'student';
        if(!item.orderItemAttr.length)return;
        item.orderItemAttr.forEach(item => {
          if(!item.traverllerCerNo)item.traverllerCerType = '';
          item.traverllerCerNo = item.traverllerCerNo.trim();
          item.traverllerEmail = item.traverllerEmail.trim();
          item.traverllerName = item.traverllerName.trim();
          item.traverllerPhone = item.traverllerPhone.trim();
        })
        // 一个二维码一个人
        if (needCertAsMedia === "true") {
          console.log('联系人1')
          item.orderItemAttr.forEach((traverller) => {
            const options = {
                ticketId: productId,
                playDate: saleDate.saleDate,
                playPeriodId: periodId,
                attrList: [traverller],
                playCount: 1,
                tag: currentTag,
                saleAgeInfos,
            };
            options.traverllerName = traverller.traverllerName;
            options.traverllerPhone = traverller.traverllerPhone;
            options.traverllerEmail = traverller.traverllerEmail;
            options.traverllerCerType = traverller.traverllerCerType;
            options.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            traverller.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            parameter.orderItems.push(options);
          });
        }else{
          console.log('联系人2')
          // 一个二维码多人
          const options = {
              ticketId: productId,
              playDate: saleDate.saleDate,
              playPeriodId: periodId,
              attrList: item.orderItemAttr,
              playCount: item.orderItemAttr.length,
              tag: currentTag,
              saleAgeInfos,
          };
          parameter.orderItems.push(options);
        };
      });
      this.upUserInfoData();
      this.upGroupUserInfo();
      // console.log(parameter.orderItems)
      // return
      if(parameter.orderItems[0].attrList[0].traverllerCerNo != "") {
        await this.mergeUsefulPersonInfos(parameter.orderItems);
      }
      // console.log(JSON.parse(window.sessionStorage.getItem('orderinformation')))
      // return
      const ticketInfoObj = JSON.parse(window.sessionStorage.getItem('orderinformation')).fullTicketInfo
      let data
      if(ticketInfoObj.hasOwnProperty('deviceNo')) {
        parameter.deviceNo = ticketInfoObj.deviceNo
        parameter.sightCode = ticketInfoObj.sightCode
        data = await getBoatCreateOrder.call(this, parameter);
      }else{
        data = await getCreateOrder.call(this, parameter);
      }
      if(!data.data)return;
      const { orderId } = data.data;
      // console.log(ticketInfoObj.hasOwnProperty('deviceNo'))
      // console.log(ticketInfoObj.hasOwnProperty('deviceNo') ? encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/boatorderdetails?orderId=${orderId}`) : encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/touristorderdetails?orderId=${orderId}`),)
      // return
      const callback = {
        orderId,
        orderType: 0,
        orderSource: 'WX',
        returnUrl:ticketInfoObj.hasOwnProperty('deviceNo') ? encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/boatorderdetails?orderId=${orderId}`) : encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/touristorderdetails?orderId=${orderId}`),
        errorUrl: ticketInfoObj.hasOwnProperty('deviceNo') ? encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/boatorderdetails?orderId=${orderId}`) : encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/touristorderdetails?orderId=${orderId}`),
      };
      window.sessionStorage.removeItem('orderinformation');
      window.sessionStorage.removeItem('controllerNumber');
      window.sessionStorage.removeItem('oftenContacts');
      this.createdDoading.loadingStata = true;
      location.href = `${process.env.VUE_APP_BASE_URL}/unified/pay?orderId=${callback.orderId}&orderSource=${callback.orderSource}&orderType=${callback.orderType}&returnUrl=${callback.returnUrl}&errorUrl=${callback.errorUrl}`;
      setTimeout(() => {
        this.createdDoading.loadingStata = false;
        this.$beyondHiding(false);
      }, 3000);
    },
    upUserInfoData(){
      const userInfo = this.userInfo;
      userInfo.mobile = this.contactItems.contactPhone;
      userInfo.name = this.contactItems.contactName;
      userInfo.email = this.contactItems.contactEmail;
      if(userInfo.idCard && this.$reg.checkIDCard(userInfo.idCard))this.contactItems.contactCerNo = userInfo.idCard;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    upGroupUserInfo(){
      // let groupUserInfo = window.sessionStorage.getItem('groupUserInfo');
      let groupUserInfo = this.userInfo.extField1
      if(!groupUserInfo)return;
      groupUserInfo = JSON.parse(groupUserInfo);
      groupUserInfo.mobile = this.contactItems.contactPhone;
      groupUserInfo.realName = this.contactItems.contactName;
      groupUserInfo.email = this.contactItems.contactEmail;
      if(groupUserInfo.idCard && this.$reg.checkIDCard(groupUserInfo.idCard))this.contactItems.contactCerNo = groupUserInfo.idCard;
      window.sessionStorage.setItem('groupUserInfo', JSON.stringify(groupUserInfo));
    },
    async mergeUsefulPersonInfos(orderItems) {
      // 本次需完成 添加 、修改
      const usefulPersonInfos = this.usefulPersonInfos;
      // 1.取出修改过的那组数据
      const selectCommonVisitors = orderItems.filter((v) => v.attrList[0].id && v.saleAgeInfos.length);
      let updateOrderItems = [];
      if (selectCommonVisitors.length) {
        updateOrderItems = selectCommonVisitors.filter((v) => {
          const item = usefulPersonInfos.find((v1) => v1.id === v.attrList[0].id);
          if (item) {
            return (
              v.attrList[0].traverllerCerNo != item.certNo ||
              v.attrList[0].traverllerCerType != item.certType ||
              v.attrList[0].traverllerEmail !== item.email ||
              v.attrList[0].traverllerName != item.name ||
              v.attrList[0].traverllerPhone != item.mobile
            );
          }
        });
      };
      if (updateOrderItems.length) {
        const updataGroup = updateOrderItems.map((v) => {
          const parameter = {
            id: v.attrList[0].id,
            userId: this.userInfo.userId,
            name: v.attrList[0].traverllerName,
            mobile: v.attrList[0].traverllerPhone,
            email: v.attrList[0].traverllerEmail || "",
            certType: v.attrList[0].traverllerCerType,
            certNo: v.attrList[0].traverllerCerNo.toUpperCase(),
            ifDefault: "1",
            personType: "traveller",
            tag: v.tag,
          };
          return getUsefulPersonUpdPerson.call(this, parameter);
        });
        // 并发发送更改的数据
        await Promise.all(updataGroup);
      };
      // 2.取出新数据
      let addOrderItems = orderItems.filter((v) => !v.attrList[0].id && v.saleAgeInfos.length);
      if (addOrderItems.length) {
        const usefulPersons = addOrderItems.map((v) => {
          const queue = v.attrList.map(v1 => {
            const parameter = {
              name: v1.traverllerName,
              mobile: v1.traverllerPhone,
              email: v1.traverllerEmail || "",
              certType: v1.traverllerCerType,
              certNo: v1.traverllerCerNo,
              tag: v.tag,
            };
            return parameter;
          });
          return queue;
        }).flat();
        await getUsefulPersonBatchAddPersonn.call(this, {
          userId: this.userInfo.userId,
          personType: "traveller",
          usefulPersons,
          certTypes: ['id_card']
        });
      };
      // 最后清空不需要的参数
      orderItems.forEach((item) => item.saleAgeInfos && delete item.saleAgeInfos);
    },
    matchContact(options) {
      switch (options.type) {
        case "needContactName":
          this.contactItems.contactName = options.value;
          this.userInfo.name = options.value;
          break;
        case "needContactMobile":
          this.contactItems.contactPhone = options.value;
          this.userInfo.mobile = options.value;
          break;
        case "needContactEmail":
          this.contactItems.contactEmail = options.value;
          this.userInfo.email = options.value;
          break;
        case "contactCerType":
          this.contactItems.contactCerType = options.value;
          break;
        case "contactCerNo":
          this.contactItems.contactCerNo = options.value;
          this.userInfo.idCard = options.value;
      }
    },
    getUserInfo() {
      this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.contactItems.contactPhone = this.userInfo.mobile;
      this.contactItems.contactName = this.userInfo.realName || this.userInfo.name;
      this.contactItems.contactEmail = this.userInfo.email;
      this.contactItems.contactCerNo = this.userInfo.idCard;
    },
    futureAgeCalculation(item){
      const { saleDate } = this.selectDate;
      const { certNo } = item;
      const checkIDCard = this.$reg.checkIDCard(certNo);
      if(checkIDCard){
        const age = this.$reg.checkAge(certNo, saleDate);
        if(age >= 25 && age < 60){
          // tag转换成人
          item.tag = 'adult';
          item.tagName = '成人';
        }else if(age >= 60){
          // tag转换老人
          item.tag = 'old_man_free';
          item.tagName = '老人';
        }
      };
    },
    async getCommonVisitors() {
      const oftenContacts = JSON.parse(sessionStorage.getItem("oftenContacts"));
      if (oftenContacts) {
        this.usefulPersonInfos = oftenContacts;
      } else {
        const certTypes = ["id_card"];
        const { data } = await getUsefulPerson({
          userId: this.userInfo.userId,
          certTypes,
        });
        const { usefulPersonInfos } = data;
        usefulPersonInfos.forEach(v => {
          this.futureAgeCalculation(v)
          v.active = false;
        });
        this.usefulPersonInfos = usefulPersonInfos;
        this.controllerNumber.some(item => {
          if(item.orderItemAttr.length){
            const { metaTicketInfo } = item;
            const currentTag = metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key === 'full' ? 'adult' : 'student';
            if(metaTicketInfo.saleAgeInfos.length){
              const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
              const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
              return this.usefulPersonInfos.some(v => {
                const { tag } = v;
                const checkAge = this.$reg.checkAge(v.certNo);
                if(((v.tag === 'un_set') && (checkAge >= travellerMinAge && checkAge <= travellerMaxAge)) || currentTag === tag){
                  v.active = true;
                  return true;
                }
              });
            }else if(this.usefulPersonInfos.length){
              this.usefulPersonInfos[0].active = true;
              return true;
            };
          }
        });
      };
      this.$fillTouristTag(this.usefulPersonInfos)
      this.$nextTick(this.updataTopContactsInputDevice);
    },
    updataTopContactsInputDevice(){
      const _controllerNumber = this.$refs.DOMInputDevice._controllerNumber;
      this.usefulPersonInfos.forEach(item => {
        if(item.active){
          const checkAge = this.$reg.checkAge(item.certNo);
          _controllerNumber.some(v => {
            const { metaTicketInfo } = v;
            if(metaTicketInfo.saleAgeInfos.length){
              const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
              const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
              const ticketTag = metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key === 'full' ? 'adult' : 'student';
              if(
                (checkAge >= travellerMinAge && checkAge <= travellerMaxAge) &&
                (v.orderItemAttr.length) &&
                (item.tag === 'un_set') ||
                (item.tag === ticketTag)){
                v.orderItemAttr.some(v1 => {
                  if(v1.traverllerCerNo)return true;
                  if(!v1.traverllerCerNo){
                    this.mergeCommonVisitors(v1, item)
                    return true;
                  }
                });
                return true;
              };
            }else{
              return v.orderItemAttr.some(v1 => {
                if(v1.traverllerCerNo)return true;
                if(!v1.traverllerCerNo){
                  this.mergeCommonVisitors(v1, item)
                  return true;
                }
              });
            }
          })
        };
      });
      this.$refs.DOMInputDevice.$forceUpdate();
    },
    changeTopContacts({ active, index, tag }){
      const { _controllerNumber } = this.$refs.DOMInputDevice;
      const currentItem = this.usefulPersonInfos[index];
      currentItem.active = active;
      if(!active){
        _controllerNumber.some(item => {
          return item.orderItemAttr.some(v => {
            if(v.traverllerCerNo === currentItem.certNo){
              v.traverllerCerNo = '';
              v.traverllerCerType = 'id_card';
              v.traverllerEmail = '';
              v.traverllerName = '';
              v.traverllerPhone = '';
              v.id = '';
              return true;
            }
          })
        });
      } else {
        // 当前选中得年龄
        let checkAge = this.$reg.checkAge(currentItem.certNo);
        if(tag === 'student'){
          checkAge = 15;
        }else if(tag === 'adult'){
          checkAge = 30;
        }else if(tag === 'old_man_free'){
          currentItem.active = false;
          return this.$toast('60周岁以上，无需购票');
        };
        const hitList = _controllerNumber.reduce((totalList, currentValue, currentIndex, arr) => {
          const { metaTicketInfo } = currentValue;
          const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
          const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
          if(checkAge >= travellerMinAge && checkAge <= travellerMaxAge && currentValue.orderItemAttr.length){
            totalList.push(currentValue);
          };
          return totalList;
        }, []);
        if(hitList.length < 2){
          // 1.自动选择区
          // 循环判断有无余量(当有余量时直接添加)
          const isSurplus = _controllerNumber.some(item => {
            const { metaTicketInfo } = item;
            const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
            const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
            if(checkAge >= travellerMinAge && checkAge <= travellerMaxAge){
              return item.orderItemAttr.some(v => {
                if(!v.traverllerName){
                  this.mergeCommonVisitors(v, currentItem)
                  return true;
                }else{
                  return false;
                };
              });
            } else {
              return false;
            };
          });
          // 2.无余量需要替换首个并且把首个得高亮关闭
          if(!isSurplus){
            // 可能会有年龄不符合的情况
            _controllerNumber.some(item => {
              const { metaTicketInfo } = item;
              const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
              const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
              if(checkAge >= travellerMinAge && checkAge <= travellerMaxAge){
                return item.orderItemAttr.some(v => {
                  if(v.traverllerName){
                    this.mergeCommonVisitors(v, currentItem)
                    v.id = currentItem.id;
                    return true;
                  }else{
                    return false;
                  };
                });
              } else {
                const isAge = _controllerNumber.filter(v => v.orderItemAttr.length).some(item => {
                  const { metaTicketInfo } = item;
                  const travellerMaxAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMaxAge);
                  const travellerMinAge = parseInt(metaTicketInfo.saleAgeInfos[0].travellerMinAge);
                  if(checkAge >= travellerMinAge && checkAge <= travellerMaxAge){
                    return true
                  };
                });
                if(!isAge)this.$toast('游客不符合适用人群年龄限制');
                return false;
              };
            });
            const usefulPersonCerNos = _controllerNumber.reduce((totalList, currentValue, currentIndex, arr) => {
              currentValue.orderItemAttr.forEach(v => totalList.push(v.traverllerCerNo));
              return totalList;
            }, []);
            this.usefulPersonInfos.forEach(item => {
              if(!usefulPersonCerNos.includes(item.certNo)){
                item.active = false;
              }
            });
          };
        }else{
          // 2.出现多个符合条件票种的自选区
          this.hitUsefulPersonInfo = hitList;
          this.usefulPersonInfoActiveIndex = index;
          this.touristShuntSwitch = true;
          this.$beyondHiding(true);
        };
      }
      this.$refs.DOMInputDevice.$forceUpdate();
    },
    needUsefulPerson(){
      return this.controllerNumber.some(item => {
        if(item.count > 0){
          const { metaTicketInfo } = item;
          if(metaTicketInfo.needTravellerEmail == 'true')return true;
          if(metaTicketInfo.needTravellerHKMTPassport == 'true')return true;
          if(metaTicketInfo.needTravellerIDCard == 'true')return true;
          if(metaTicketInfo.needTravellerMilitarycard == 'true')return true;
          if(metaTicketInfo.needTravellerMobile == 'true')return true;
          if(metaTicketInfo.needTravellerName == 'true')return true;
          if(metaTicketInfo.needTravellerOther == 'true')return true;
          if(metaTicketInfo.needTravellerPRC == 'true')return true;
          if(metaTicketInfo.needTravellerPassport == 'true')return true;
          return false;
        }
      })
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        const fullPrice = newValue.reduce((total, currentValue, currentIndex, arr) => {
          total += Number(currentValue.salePrice) * currentValue.count;
          return total;
        }, 0);
        this.fullPrice = String(fullPrice.toFixed(2)).padStart(2, 0);
      },
      deep: true,
    }
  },
  components: {
    ticketInfo,
    fillContacts,
    topContacts,
    inputDevice,
    calculationAction,
    multiTicketDiversion,
  }
};
</script>
